import { render, staticRenderFns } from "./SidebarFields.vue?vue&type=template&id=63909c6c&scoped=true&"
import script from "./SidebarFields.vue?vue&type=script&lang=js&"
export * from "./SidebarFields.vue?vue&type=script&lang=js&"
import style0 from "./SidebarFields.vue?vue&type=style&index=0&id=63909c6c&prod&lang=css&"
import style1 from "./SidebarFields.vue?vue&type=style&index=1&id=63909c6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63909c6c",
  null
  
)

export default component.exports